export default {
  getEmployeesList: 'GET_EMPLOYEES_LIST',
  getEmployeesListSuccess: 'GET_EMPLOYEES_LIST_SUCCESS',
  getEmployeesListFailed: 'GET_EMPLOYEES_LIST_FAILED',
  addNewEmployee: 'ADD_NEW_EMPLOYEE',
  addNewEmployeeSuccess: 'ADD_NEW_EMPLOYEE_SUCCESS',
  addNewEmployeeFailed: 'ADD_NEW_EMPLOYEE_FAILED',
  toggleEmployeeForm: 'TOGGLE_EMPLOYEE_FORM',
  resetToInitialState: 'EMPLOYEE_FORM_RESET_TO_INITIAL_STATE',
  updateEmployeeDetails: 'UPDATE_EMPLOYEE_DETAILS',
  updateEmployeeDetailsSuccess: 'UPDATE_EMPLOYEE_DETAILS_SUCCESS',
  updateEmployeeDetailsFailed: 'UPDATE_EMPLOYEE_DETAILS_FAILED',
  employeeProfileUpdate: 'EMPLOYEE_PROFILE_UPDATE',
  employeeProfileUpdateSuccess: 'EMPLOYEE_PROFILE_UPDATE_SUCCESS',
  employeeProfileUpdateFailed: 'EMPLOYEE_PROFILE_UPDATE_FAILED',
  deleteEmployee: 'DELETE_EMPLOYEE',
  deleteEmployeeSuccess: 'DELETE_EMPLOYEE_SUCCESS',
  deleteEmployeeFailed: 'DELETE_EMPLOYEE_FAILED',
};
